import { render, staticRenderFns } from "./EmailButton.vue?vue&type=template&id=3999b548&scoped=true&"
import script from "./EmailButton.vue?vue&type=script&lang=js&"
export * from "./EmailButton.vue?vue&type=script&lang=js&"
import style0 from "./EmailButton.vue?vue&type=style&index=0&id=3999b548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999b548",
  null
  
)

export default component.exports